import React from "react";
import resumeCraftImg from "../../../assets/projects/resumeCraft.png";
import { FiGithub } from "react-icons/fi";
import { FiExternalLink } from "react-icons/fi";
import { HiCode } from "react-icons/hi";

const Project1 = () => {
  const resumeCraft = {
    projectName: "1. Resume Craft",
    image: resumeCraftImg,
    description:
      "Resume Craft, created by Team Binary Heroes, streamlines resume and cover letter creation. Users effortlessly build professional-grade documents, customize templates, and securely store and share their work. With seamless integration with professional networking platforms, Resume Craft offers a streamlined path to career advancement.",
    technologies: [
      "React",
      "Typescript",
      "Redux",
      "Tailwind CSS",
      "MongoDB",
      "Mongose",
      "Express.js",
      "Firebase",
    ],
    gitHub: "https://github.com/Lihan37/Resume-Craft",
    live: "https://resumecraft01.netlify.app/",
  };

  return (
    <div className="bg-[#f9f9f9] ">
      <div className="lg:max-w-[1200px] mx-auto flex flex-col-reverse lg:flex-row gap-5 justify-between py-20 px-6 md:px-12 lg:px-2">
        <div className="flex-1 ">
          <h1 className="flex items-center ">
            <span className="text-2xl font-bold ">
              {resumeCraft.projectName}
            </span>{" "}
            <span className="text-[#2979ff] font-bold ml-3">
              (Team Project)
            </span>
          </h1>
          <p className="text-justify mt-5">{resumeCraft.description}</p>

          <div>
            <h2 className="text-xl font-semibold my-4">Technology</h2>
            <ul>
              {resumeCraft.technologies.map((tech, index) => (
                <li key={index} className="flex gap-1 items-center">
                  🔷<span> {tech}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-10 flex gap-5">
            <p className="bg-[#2979ff] text-white px-5 py-2 rounded">
              <a
                href={resumeCraft.gitHub}
                target="_blank"
                rel="noreferrer"
                className="flex gap-2 items-center"
              >
                <FiGithub className="text-2xl " />{" "}
                <span className="font-semibold">Code</span>
              </a>
            </p>
            <p className="bg-[#2979ff] text-white px-5 py-2 rounded">
              <a
                href={resumeCraft.live}
                target="_blank"
                rel="noreferrer"
                className="flex gap-2 items-center"
              >
                <FiExternalLink className="text-2xl " />
                <span className="font-semibold">Live</span>
              </a>
            </p>
          </div>
        </div>
        <div className="flex-1">
          <img src={resumeCraft.image} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Project1;
